class DocumentationAdvancedViewPaginator {

    constructor() {
        this._advancedViewDocumentsTemplate = null;
        this._advancedViewDocumentsData = new AdvancedViewDocumentsData();

        this._loadTemplates();

    }

    _resizing() {
        $('.advanced-view-video-container').each(function() {
            var v = $(this);
            var h = Number(v.attr('data-height'));
            var w = Number(v.attr('data-width'));

            if (!h || !w) return;

            v.height(v.width()*h/w);
        });
    }

    _loadTemplates() {
        this._advancedViewDocumentsTemplate = Handlebars.compile($("#documentationAdvancedViewDocuments").html());

        $(window).resize(this._resizing);
    }

    _drawDocumentsList() {
        const folder = this._advancedViewDocumentsData.getFolder();
        const docs = documentationScreenController.getFolderDocuments(folder);

        documentationScreenController.sortDocumentElements(docs);
        documentationScreenController.setExtraDocumentsInfo(docs, folder);

        const context = this._advancedViewDocumentsData.getContext();

        _.forEach(docs, function(doc, index) {
            doc.index = index;
        });

        context.documents = docs;

        baseController.stackSimpleContent(documentationScreenController.advancedTemplate, context);

        const $documentationList = $(documentationScreenController.screen).find("#documentation-documents");
        $documentationList.html(this._advancedViewDocumentsTemplate(context));

        documentationScreenController.setDocumentsMargins(docs);
        documentationScreenController.setCarouselConfig(folder);
        documentationScreenController.setFolderNameEllipsis(folder);
        documentationScreenController.setAdvancedDocumentsConfig();
        documentationScreenController.setAdvancedViewEvents(folder);
        documentationScreenController.decorateElements();

        smartListsController.initialize();

        documentationScreenController.documentationGoUp.setButtonStyle(folder.id);
        documentationScreenController.documentationGoUp.setButtonPosition(folder.id, true);
        documentationScreenController.documentationNew.setButtonPosition(folder.id, true);
        documentationScreenController.documentationFilters.filtersManagement(folder.id);

        if (folder) {
            documentationScreenController.manageDocumentContainers(folder);
        }

        this._manageDocumentsPagination();

        this._resizing();
    }

    drawMoreDocuments(folder) {

        const docs = documentationScreenController.getFolderDocuments(folder);

        documentationScreenController.sortDocumentElements(docs);
        documentationScreenController.setExtraDocumentsInfo(docs, folder);

        const context = this._advancedViewDocumentsData.getContext();

        const lastDocumentIndex = parseInt($(documentationScreenController.screen).find("#documentation-documents li").last().attr("row-data-index"));

        _.forEach(docs, function(doc, index) {
            doc.index =  lastDocumentIndex + index + 1;
        });

        context.documents = docs;

        const $documentationList = $(documentationScreenController.screen).find("#documentation-documents");

        $documentationList.append(this._advancedViewDocumentsTemplate(context));

        documentationScreenController.setDocumentsMargins(docs);
        documentationScreenController.setCarouselConfig(folder);
        documentationScreenController.setAdvancedDocumentsConfig();
        documentationScreenController.setAdvancedViewEvents(folder);
        documentationScreenController.decorateElements();

        if (folder) {
            documentationScreenController.manageDocumentContainers(folder);
        }

        this._resizing();
    }

    _manageDocumentsPagination() {

        function removeEvents() {
            $containerScroll.off("wheel.getMoreDocuments touchmove.getMoreDocuments");
        }

        function getMoreDocuments() {

            const folderId = folder.id;

            api.getFolderDocuments(folderId, pageNumber, documentationScreenController.documentationPageSize, function(response) {

                $loader.hide();
                pendingRequest = false;
                pageNumber += 1;

                folder.documents = _.concat(folder.documents, response.result.documents);

                that.drawMoreDocuments(response.result);

            }, false);

        }

        function onScrollBottom() {

            const scrollHeight = $containerScroll[0].scrollHeight;
            const bodyHeight = $containerScroll[0].clientHeight;
            const currentScrollPosition = $(window).scrollTop();
            const distanceToBottom = 100;

            if (currentScrollPosition > lastScrollPosition && currentScrollPosition + bodyHeight >= scrollHeight - distanceToBottom) {

                if (!pendingRequest) {

                    $loader.show();
                    pendingRequest = true;
                    getMoreDocuments();

                }

            }

            lastScrollPosition = currentScrollPosition;

        }

        const that = this;
        const folder = this._advancedViewDocumentsData.getFolder();
        const $loader = $(documentationScreenController.screen).find(".documentation-paginator-loader");
        const $containerScroll = $("body");
        const $backButton = $(".documentation-folder-header-back-btn");
        const $changeModeViewButton = $(".toggle-advanced-view-mode");
        let lastScrollPosition = 0;
        let pendingRequest = false;
        let pageNumber = $(documentationScreenController.screen).find("#documentation-documents li").length / documentationScreenController.documentationPageSize;
        let scrollTimeout = null;

        removeEvents();

        $containerScroll.on("wheel.getMoreDocuments touchmove.getMoreDocuments", function() {

            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function(){
                documentationScreenController.scrollPosition = $(window).scrollTop();
            }, 100);

            documentationScreenController.scrollPosition = $(window).scrollTop();

            const isDocumentationVisible = $(documentationScreenController.screen).is(":visible");
            const isFolder = $(documentationScreenController.screen).find("#documentation-documents").children().length === 0;
            const hasDocumentsLeft = $(documentationScreenController.screen).find("#documentation-documents li").length < folder.total_document_children;

            if (isDocumentationVisible && !isFolder && hasDocumentsLeft) {
                onScrollBottom();
            }

        });

        $backButton.one("click", removeEvents);
        $changeModeViewButton.one("click", removeEvents);

    }

    initialize(folder, isRootFolder, difficultyTimesFormatted, difficultyPointsFormatted, documentTags) {

        this._advancedViewDocumentsData.setFolder(folder);
        this._advancedViewDocumentsData.setIsRootFolder(isRootFolder);
        this._advancedViewDocumentsData.setDifficultyTimesFormatted(difficultyTimesFormatted);
        this._advancedViewDocumentsData.setDifficultyPointsFormatted(difficultyPointsFormatted);
        this._advancedViewDocumentsData.setDocumentTags(documentTags);

        if ($(".documentation-documents-" + folder.id).length === 0) {
            this._drawDocumentsList();
        } else {
            this._manageDocumentsPagination();
        }

    }

}